<template>
  <yd-dialog :title="'发积分'" :visible.sync="showScore" append-to-body width="450px">
    <el-form :model="form" ref="scoreForm" :rules="rules" size="mini" label-width="100px">
      <el-form-item label="发放数量" prop="score">
        <!-- <el-input type="number" v-model.trim="form.score" placeholder="请输入数字" clearable /> -->
        <el-input-number
          v-model="form.score"
          placeholder="请输入"
          :controls="false"
          :precision="0"
          :min="1"
          style="width: 100%"
        />
      </el-form-item>
      <el-form-item label="原因" prop="remark">
        <el-input
          type="textarea"
          v-model.trim="form.remark"
          placeholder="请输入，限制200字"
          maxlength="200"
          show-word-limit
          :rows="3"
        />
      </el-form-item>
    </el-form>
    <template #footer>
      <el-button @click="closeScoreDialog" size="mini">取 消</el-button>
      <el-button type="primary" @click="handleConfirm" size="mini" :loading="loading"
        >确 定</el-button
      >
    </template>
  </yd-dialog>
</template>

<script >
import { Message } from 'element-ui';
import { ref, reactive, inject, watch } from '@vue/composition-api';
import { addScore } from '@/api/crm/user.js';
const __sfc_main = {};
__sfc_main.setup = (__props, __ctx) => {
  const showScore = inject('showScore');
  const selectedUserArr = inject('selectedUserArr');
  // 关闭弹窗
  const closeScoreDialog = inject('closeScoreDialog');
  // 查用户详情
  const getUserInfo = inject('getUserInfo');
  const logSearch = inject('logSearch');

  // 表单数据
  const form = ref({});
  const scoreForm = ref({});
  // 初始化表单数据
  const initFormData = () => {
    form.value = {
      score: undefined,
      remark: undefined,
      userIds: []
    };
    form.value.userIds = selectedUserArr.value.map(item => {
      return item.userId;
    });
    // 监听弹窗打开，清除校验
    scoreForm.value.clearValidate && scoreForm.value.clearValidate();
  };
  watch(showScore, newVal => {
    if (newVal && selectedUserArr.value) {
      initFormData();
    }
  });

  // 表单项校验
  const createCheckFun = (min, max, msg) => {
    return (rule, value, callback) => {
      if (!value && value !== 0) {
        callback(new Error('请输入发放数量'));
        return;
      }
      if (!/^[1-9]\d*$/.test(value)) {
        callback(new Error('请输入正整数'));
        return;
      }
      if (parseInt(value) > max || parseInt(value) < min) {
        callback(new Error(msg));
        return;
      }
      callback();
    };
  };
  // 表单项校验规则
  const rules = reactive({
    score: [{
      required: true,
      validator: createCheckFun(1, Infinity, '最小值为1'),
      trigger: 'blur'
    }],
    remark: [{
      required: true,
      message: '请输入原因',
      trigger: 'blur'
    }]
  });

  // 发放积分
  const loading = ref(false);
  const handleConfirm = () => {
    scoreForm.value.validate(async valid => {
      if (!valid) {
        return;
      }
      loading.value = true;
      const {
        code
      } = await addScore(form.value);
      loading.value = false;
      if (code !== 0) {
        return;
      }
      Message.success('积分发放成功');
      closeScoreDialog();
      logSearch && logSearch();
      // 刷新用户详情
      const row = selectedUserArr.value && selectedUserArr.value.length > 0 ? selectedUserArr.value[0] : {};
      const phone = row.phone || row.mobilePhone;
      getUserInfo && getUserInfo(phone);
    });
  };
  return {
    showScore,
    closeScoreDialog,
    form,
    scoreForm,
    rules,
    loading,
    handleConfirm
  };
};
export default __sfc_main;
</script>

<style lang="scss" scoped>
  ::v-deep .el-input-number .el-input__inner {
    text-align: left;
  }
</style>
